(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.formly.inputs.state-select'
  var options = require('./states-data')

  require('angular')
    .module(MODULE_NAME, [])
    .run(stateSelectConfig)

  stateSelectConfig.$inject = ['formlyConfig']
  function stateSelectConfig (formlyConfig) {
    formlyConfig.setType({
      name: 'state-select',
      extends: 'select',
      defaultOptions: {
        templateOptions: {
          options: options
        }
      }
    })
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/state-select/index.js